import React from 'react';

import ReactDOM from 'react-dom';
// Libs
import router from '../../lib/router.js';

import events from '../../lib/events.js';

import sessionService from '../../services/sessionService.jsx';

import Loader from '../components/loader.jsx';
// Register in router
let render = (container) => {
  console.info('[UI.page.signIn] rendering page');
  if (sessionService.isSignedIn()) {
    window.location.hash = '#';
  } else {
    ReactDOM.render(<PageSignIn />, container);
    events.publish('page-change', {page: 'signIn'});
  }
};

console.info('[UI.page.signIn] register route');
router.rr.add([{path: 'signIn', handler: render}]);

// Register login handler
events.subscribe('http-error', data => {
  if (data.xhr.status === 401) {
    sessionService.setUser(null);
    console.warn('received a 401 error, redirecting to login.');
    window.location.hash = '#signIn';
  }
});

// Page object
class PageSignIn extends React.Component {
  componentDidMount() {
    setTimeout(() => {
      window.location.href = window.loginURL;
    }, 700);
  }

  render() {
    return <div id='page-sign-in'>
      <Loader loaded={false}/>
    </div>;
  }
}

export default PageSignIn;
